import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { HeroDemo } from "./HeroDemo";

/** Atraso do marca-texto da manchete, depois que a pagina pinta. */
const HEADLINE_MARK_DELAY_MS = 450;

export function Hero(): JSX.Element {
  const [marked, setMarked] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setMarked(true), HEADLINE_MARK_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <section aria-labelledby="hero-heading" className="relative overflow-hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 top-10 h-[640px] w-[820px] rounded-full opacity-[0.09] blur-3xl"
        style={{ background: "radial-gradient(closest-side, hsl(var(--signal)), transparent)" }}
      />
      <div className="relative mx-auto grid max-w-[77.5rem] items-center gap-12 px-4 pb-20 pt-12 sm:px-6 sm:pt-16 lg:min-h-[calc(100dvh-4rem)] lg:grid-cols-[minmax(0,1.12fr)_minmax(0,1fr)] lg:gap-14 lg:px-8 lg:py-16">
        <div>
          <h1
            id="hero-heading"
            className="text-[clamp(2.5rem,1.6rem+2.6vw,3.6rem)] font-bold leading-[1.04] tracking-[-0.04em]"
          >
            O link chega com a tag de outro.
            <br />
            Sai com a{" "}
            <span className="lp-marker" data-on={marked}>
              sua
            </span>
            .
          </h1>
          <p className="mt-6 max-w-[34rem] text-lg leading-relaxed text-muted-foreground">
            Um bot lê as ofertas dos seus grupos de Telegram e WhatsApp e troca cada link pelo seu, antes de publicar.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-3">
            <Button asChild variant="signal" size="lg" className="lp-press">
              <Link to="/cadastro">
                Criar conta grátis
                <ArrowRight size={18} aria-hidden="true" />
              </Link>
            </Button>
            <Button asChild variant="ghost" size="lg" className="lp-press text-foreground">
              <a href="#precos">Ver planos</a>
            </Button>
          </div>
        </div>

        <HeroDemo />
      </div>
    </section>
  );
}
